$(document).ready(function() {
	// copy email address to clipboard and show tooltip
	var mailto_links = $('a[href^="mailto"]');
	$(mailto_links).each(function(index, link) {
		$(link).on('click', function(e) {
			e.preventDefault();
			var href = $(link).attr('href');
			var email_address = href.replace('mailto:', '');
			navigator.clipboard.writeText(email_address);
			$(link).addClass('tooltip-active');
			setTimeout(() => {
				$(link).removeClass('tooltip-active');
			}, 1500);
		});
	});

	// big color wipe page transition
	var main_menu_links = $('#main-menu a');
	if (main_menu_links.length) {
		$(main_menu_links).each(function(index, link) {
			$(link).on('click', function(e) {
				e.preventDefault();
				// TRY THIS TO GET RID OF WEIRD FLASH ON TRANSITION
				$('.tommy-menu-image').removeClass('.tommy-menu-image-active');
				if ($('body').hasClass('tommy-page-transitioning')) {
					$('body').removeClass('tommy-page-transitioning');
					var thing = $('.tommy-page-transition');
					var new_thing = $(thing).clone();
					thing.before(new_thing);
					$('.' + thing.attr('class') + ':last').remove();
				}
				var destination_url = $(link).attr('href');
				var background_color = $(link).attr('data-background-color');
				$('.tommy-page-transition').css('background-color', background_color);
				$('body').addClass('tommy-page-transitioning');
				setTimeout(() => {
					window.location.href = destination_url;
				}, 251);
			});
		});
	}

	// show project images when hovering on link to project
	$('.home #main-menu a').on('mouseenter', tommy_show_menu_image).on('mouseleave', tommy_hide_menu_image);
	function tommy_show_menu_image() {
		var menu_slug = $(this).attr('data-menu-slug');
		$('.tommy-menu-image[data-menu-slug="' + menu_slug + '"]').addClass('tommy-menu-image-active');
	}
	function tommy_hide_menu_image() {
		var menu_slug = $(this).attr('data-menu-slug');
		$('.tommy-menu-image[data-menu-slug="' + menu_slug + '"]').removeClass('tommy-menu-image-active');
	}

	// project assets fade in and up
	const assets = document.querySelectorAll('.tommy-project-asset');
	if (assets) {
		const observer = new IntersectionObserver(entries => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					console.log(entry);
					$(entry.target).addClass('tommy-project-asset-active');
				}
			});
		}, { threshold: 0.25 });
		assets.forEach(asset => {
			observer.observe(asset);
		});
	}

	// fade to black on project footers
	const project_footer = document.querySelector('.tommy-project-footer');
	if (project_footer) {
		const observer = new IntersectionObserver(entries => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					$('body').addClass('tommy-project-footer-active');
				} else {
					$('body').removeClass('tommy-project-footer-active');
				}
			});
		}, { threshold: 1 });
		observer.observe(project_footer);
	}

	// password protect form
	$('#protected-post-form').on('submit', function(e) {
		e.preventDefault();

		var form = $(this);
		var password = $('input[name="post_password"]').val();
		var post_id = $('input[name="post_id"]').val();
		var nonce = $('#tommy-password-verify-nonce').val();

		console.log('form:', form);
		console.log('password:', password);
		console.log('post_id:', post_id);
		console.log('nonce:', nonce);

		$.ajax({
			type: 'post',
			url: '/wp/wp-admin/admin-ajax.php',
			data: {
				action: 'tommy_verify_password',
				password: password,
				pid: post_id,
				nonce: nonce
			},
			success: function(results) {
				var results = JSON.parse(results);
				console.log(results);
				if (results.status === 'success') {
					$(form).removeClass('protected-post-form-success protected-post-form-error').addClass('protected-post-form-success');
					setTimeout(function() {
						location.reload();
					}, 2000);
				} else if (results.status === 'error') {
					$(form).removeClass('protected-post-form-error protected-post-form-success').addClass('protected-post-form-error');
					$('input[type="password"]', form).removeAttr('value');
				}
			},
			error: function(results) {
				var results = JSON.parse(results);
				console.log(results);
				$(form).removeClass('protected-post-form-error protected-post-form-success').addClass('protected-post-form-error');
				$('input[type="password"]', form).removeAttr('value');
			}
		});
	});

	if ($('body').hasClass('page-template-page-about')) {
		// dvd screensaver gimmick
		var box = document.querySelector('.tommy-dvd-menu-image'),
			// colors = ['#ff0000', '#ff4000', '#ff8000', '#ffbf00', '#ffff00', '#bfff00', '#80ff00', '#40ff00', '#00ff00', '#00ff40', '#00ff80', '#00ffbf', '#00ffff', '#00bfff', '#0080ff', '#0040ff', '#0000ff', '#4000ff', '#8000ff', '#bf00ff', '#ff00ff', '#ff00bf', '#ff0080', '#ff0040', '#ff0000'],
			// currentColor = Math.floor((Math.random() * 25) + 1),
			win = window,
			ww = win.innerWidth,
			wh = win.innerHeight,
			translateX = Math.floor((Math.random() * ww) + 1),
			translateY = Math.floor((Math.random() * wh) + 1),
			boxWidth = box.offsetWidth,
			boxHeight = box.offsetHeight,
			boxTop = box.offsetTop,
			boxLeft = box.offsetLeft,
			xMin = -boxLeft,
			yMin = -boxTop,
			xMax = win.innerWidth - boxLeft - boxWidth,
			yMax = win.innerHeight - boxTop - boxHeight,
			request = null,
			direction = 'se',
			speed = parseFloat(box.getAttribute('data-speed')),
			timeout = null;

		init();

		// reset constraints on resize
		window.addEventListener('resize', function(argument) {
			clearTimeout(timeout);
			timeout = setTimeout(update, 100);
		}, false);

		function init() {
			request = requestAnimationFrame(init);
			move();
			// setInterval(function() {
			//   move();
			// }, 16.66);
		}

		// reset constraints
		function update() {
			xMin = -boxLeft;
			yMin = -boxTop;
			xMax = win.innerWidth - boxLeft - boxWidth;
			yMax = win.innerHeight - boxTop - boxHeight;
		}

		function move() {
			setDirection();
			setStyle(box, {
				transform: 'translate3d(' + translateX + 'px, ' + translateY + 'px, 0)',
			});
		}

		function setDirection() {
			switch (direction) {
				case 'ne':
					translateX += speed;
					translateY -= speed;
					break;
				case 'nw':
					translateX -= speed;
					translateY -= speed;
					break;
				case 'se':
					translateX += speed;
					translateY += speed;
					break;
				case 'sw':
					translateX -= speed;
					translateY += speed;
					break;
			}
			setLimits();
		}

		function setLimits() {
			if (translateY <= yMin) {
				if (direction == 'nw') {
					direction = 'sw';
				} else if (direction == 'ne') {
					direction = 'se';
				}
				switchImage();
				// switchColor();
			}
			if (translateY >= yMax) {
				if (direction == 'se') {
					direction = 'ne';
				} else if (direction == 'sw') {
					direction = 'nw';
				}
				switchImage();
				// switchColor();
			}
			if (translateX <= xMin) {
				if (direction == 'nw') {
					direction = 'ne';
				} else if (direction == 'sw') {
					direction = 'se';
				}
				switchImage();
				// switchColor();
			}
			if (translateX >= xMax) {
				if (direction == 'ne') {
					direction = 'nw';
				} else if (direction == 'se') {
					direction = 'sw';
				}
				switchImage();
				// switchColor();
			}
		}

		function switchImage() {
			const images = JSON.parse(document.querySelector('.tommy-dvd-menu-image').getAttribute('data-images'));
			const random_array_key = (Math.floor(Math.random() * images.length));
			const image = images[random_array_key];
			var box = document.querySelector('.tommy-dvd-menu-image img');
			box.setAttribute('src', image['1x']);
			box.setAttribute('srcset', image['1x'] + ', ' + image['2x'] + ' 2x');
			box.setAttribute('alt', image['alt']);
			// console.log(box);
		}

		// function switchColor() {
		// 	var color = Math.floor((Math.random() * 25) + 1);
		//
		// 	while( color == currentColor ) {
		// 		color = Math.floor((Math.random() * 25) + 1)
		// 	}
		//
		// 	setStyle(box, {
		// 		color: colors[color]
		// 	});
		//
		// 	currentColor = color;
		// }

		function getVendor() {
			var ua = navigator.userAgent.toLowerCase(),
				match = /opera/.exec(ua) || /msie/.exec(ua) || /firefox/.exec(ua) || /(chrome|safari)/.exec(ua) || /trident/.exec(ua),
				vendors = {
					opera: '-o-',
					chrome: '-webkit-',
					safari: '-webkit-',
					firefox: '-moz-',
					trident: '-ms-',
					msie: '-ms-',
				};

			return vendors[match[0]];
		};

		function setStyle(element, properties) {
			var prefix = getVendor(),
				property, css = '';
			for (property in properties) {
				css += property + ': ' + properties[property] + ';';
				css += prefix + property + ': ' + properties[property] + ';';
			}
			element.style.cssText += css;
		}
	}

});
